import { DatePicker, Radio } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { colorsLight } from '../../../assets/colors/light';
import CloudWhiteIcon from '../../../assets/icons/cloud.svg';
import CloudBlueIcon from '../../../assets/icons/cloud_blue.svg';
import LocalBlueIcon from '../../../assets/icons/computer_blue.svg';
import LocalWhiteIcon from '../../../assets/icons/computer_white.svg';
import LazyloadingSelect from '../../../components/LazyloadingSelect/LazyloadingSelect';
import * as SERVICE from '../../../constants/service.types';
import moment from 'moment';

const FilterPlayback = ({
  selectedDate,
  setSelectedDate,
  selectedCamera,
  onChangeSelectCamera,
  selectedCameraGroup,
  onChangeSelect,
  viewType,
  onChangeViewType,
  onChangeDate,
}) => {
  const { camerasDate } = useSelector((state) => state);
  const { t } = useTranslation();
  return (
    <div style={{ padding: 10 }}>
      <div style={{ marginBottom: 10 }}>
        <Radio.Group
          style={{
            background: '#1757B7',
            padding: '4px',
            borderRadius: '20px',
          }}
          onChange={onChangeViewType}
          value={viewType}
        >
          <Radio.Button
            value={1}
            style={{
              color: viewType === 1 ? '#1757B7' : '#fff',
              background: viewType === 1 ? '#fff' : '#1757B7',
              borderRadius: '20px',
              border: 'none',
              lineHeight: '27px',
              height: 'unset',
            }}
          >
            <img
              src={viewType === 1 ? LocalBlueIcon : LocalWhiteIcon}
              alt="Local"
              style={{ width: 16, marginRight: 5 }}
            />
            On Local
          </Radio.Button>
          <Radio.Button
            value={2}
            style={{
              height: 'unset',
              borderRadius: '20px',
              lineHeight: '27px',
              border: 'none',
              color: viewType === 2 ? '#1757B7' : '#fff',
              background: viewType === 2 ? '#fff' : '#1757B7',
            }}
          >
            <img
              src={viewType === 2 ? CloudBlueIcon : CloudWhiteIcon}
              alt="Local"
              style={{ width: 16, marginRight: 5 }}
            />
            On Cloud
          </Radio.Button>
        </Radio.Group>
      </div>
      <div style={{ width: '100%', marginBottom: 10 }}>
        <LazyloadingSelect
          showArrow
          size={10}
          value={selectedCameraGroup}
          onChange={onChangeSelect}
          serviceId={SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2}
          searchField="name"
          reduxVariableName="listDeviceGroupByPage"
          defaultOption={{ value: 0, label: t('All group') }}
          convertOptionData={(listDeviceGroupByPage) =>
            listDeviceGroupByPage.deviceGroups?.map((item) => ({
              ...item,
              value: item.id,
              label: item.name,
            }))
          }
          selectProps={{
            style: { width: '100%' },
          }}
        />
      </div>
      <div style={{ width: '100%', marginBottom: 10 }}>
        <LazyloadingSelect
          showArrow
          mode="multiple"
          size={10}
          value={selectedCamera}
          onChange={onChangeSelectCamera}
          searchField="name"
          deviceGroupId={
            selectedCameraGroup.value === 0
              ? undefined
              : selectedCameraGroup.value
          }
          serviceId={
            selectedCameraGroup.value === 0
              ? SERVICE.LIST_ALL_DEVICE_BY_PAGE
              : SERVICE.GET_DEVICE_GROUP_BY_ID
          }
          reduxVariableName={
            selectedCameraGroup.value === 0 ? 'cameras' : 'deviceGroupData'
          }
          convertOptionData={(deviceGroupData) => {
            const data =
              selectedCameraGroup.value === 0
                ? deviceGroupData?.data
                : deviceGroupData?.deviceGroup?.devices;

            return (
              data?.map((item) => ({
                ...item,
                value: item.serial,
                label: item.name,
              })) ?? []
            );
          }}
          selectProps={{
            style: { width: '100%' },
          }}
        />
      </div>
      <div style={{ width: '100%', marginBottom: 10 }}>
        <DatePicker
          dateRender={(current) => {
            const style = {};
            if (
              camerasDate &&
              camerasDate.find((x) => x === current.format('MM-DD-YYYY'))
            ) {
              style.color = colorsLight.$darkest;
              style.borderBottom = '1px solid #1757B7';
            }
            return (
              <div className="ant-picker-cell-inner" style={style}>
                {current.date()}
              </div>
            );
          }}
          className="picker"
          format="DD-MM-YYYY"
          placeholder={t('Select date')}
          defaultValue={selectedDate}
          disabledDate={(current) => {
            return (
              current > moment().endOf('day') ||
              current < moment().subtract(6, 'months')
            );
          }}
          style={{
            width: '100%',
            height: '31.5px',
          }}
          onChange={(value) => {
            setSelectedDate(value);
            onChangeDate(value);
          }}
        />
      </div>
    </div>
  );
};

export default FilterPlayback;
